<section class="error-wrapper container">
    <div class="col-md-12">
    <f-alert variant="error"
        [ngClass]="rootScope.isGENSYSErrorToHide ? 'hide' : 'hide1'">{{rootScope.errorMsg}}</f-alert>
    <f-alert variant="error"
        [ngClass]="rootScope.isGensysUDPErrorToHide ? 'hide' : 'hide1'">{{rootScope.errorMsg}}</f-alert>
   
   <f-alert variant="warning" [ngClass]="isWarningToHide ? 'hide' : 'hide1'" is-dismissable="true" 
        (alertDismissed)="closeWarning()">
        <span [innerHTML]="rootScope.warningMsg">{{rootScope.warningMsg}} </span></f-alert>

    

    <f-alert variant="error" [ngClass]="isErrorToHide ? 'hide' : 'hide1'">{{rootScope.errorMsg}}</f-alert>
    <f-alert variant="info" [ngClass]="isInfoToHide ? 'hide' : 'hide1'">{{rootScope.infoMsg}}</f-alert>
    <f-alert variant="success" [ngClass]="isSuccessToHide ? 'hide' : 'hide1'">{{rootScope.successMsg}}</f-alert>
    </div>
</section>